import { Component, Input } from "@angular/core";
import { ServiceControllerStatusEnum } from "../../../../models/windows-service";

@Component({
  selector: "monitoring-status",
  templateUrl: "./monitoring-status.component.html",
  styleUrls: ["./monitoring-status.component.scss"]
})
export class MonitoringStatusComponent {

  @Input() status!: number;

  monitoringStatuses = ServiceControllerStatusEnum;
}
